import * as _ from 'lodash';

export const deepTransform = (obj, iterator) =>  _.transform(obj, (acc, val, key) => {
    const isObject = _.isObject(val);
    // use the iterator and get a pair of key and value
    const [k, v] = iterator(key, val, isObject);
    // skip if no updated key
    if (!_.isUndefined(k))
    {
        // set the updated key and value, and if the value is an object iterate it as well
        // plus special shenaningans if this is an array to remove empty values like [empty, {...}]
        let val = v;
        if (isObject)
        {

            val = deepTransform(v, iterator);
            if (_.isArray(val))
            {
                val = val.filter(e => !_.isEmpty(e));
            }
        }
        acc[k] = val;
    }
});